module.exports = __webpack_public_path__ + "img/main-jen_m.b533b533.jpg";